var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0387 7.99277L12.5068 6.46094L2.41667 16.5511V18.0829H3.9485L14.0387 7.99277ZM15.5705 6.46094L17.1023 4.9291L15.5705 3.39727L14.0387 4.9291L15.5705 6.46094ZM4.8455 20.2496H0.25V15.653L14.8046 1.09844C15.0077 0.895342 15.2832 0.78125 15.5705 0.78125C15.8578 0.78125 16.1333 0.895342 16.3364 1.09844L19.4012 4.16319C19.6043 4.36634 19.7184 4.64184 19.7184 4.9291C19.7184 5.21636 19.6043 5.49186 19.4012 5.69502L4.84658 20.2496H4.8455Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.94901c7a57a7c426497ad7cf586d0382.svg";
export { ForwardRef as ReactComponent };